import viewChat from "../../assets/icn/viewChat.webp";
import Image from "next/image";
import Actions from "@/elements/Actions";
import Link from "next/link";
import NseOrBsePrice from "@/elements/NseOrBsePrice/NseOrBsePrice";
import { useEffect, useState } from "react";
import { useSubscription } from "react-stomp-hooks";
import LivePriceBox from "@/elements/LivePriceBox/LivePriceBox";
import { useRouter } from "next/router";
import OnHoverOption from "../PaidUsers/OnHoverOption";
import { futureName, putComma } from "@/lib/utils";
import { getLivePrice } from "@/lib/tradeCards";

function putCommaWith(value) {
    if (parseInt(value) && !value?.includes("/") && !value?.includes("-")) {
        return putComma(parseInt(value));
    } else {
        return value;
    }
}

const specialScreeners = ["TOP_RESULTS_TO_WATCH", "MULTI_BAGGER_STOCKS"];

export default function StockCard({ data, ele, name }) {
    const router = useRouter();
    const [ltpPrice, setLtpPrice] = useState(ele.nseSymbol ? ele.nseLtpPrice : ele.bseLtpPrice);
    useEffect(() => {
        setLtpPrice(ele.nseSymbol ? ele.nseLtpPrice : ele.bseLtpPrice);
    }, [ele?.finCode]);

    useSubscription(`/stock/live-price/${ele?.finCode}`, (res) => setLtpPrice(JSON.parse(res.body)?.ltpPrice));
    const [isOpen, setOpen] = useState(false);
    return (
        <tr className="font-Inter font-semibold text-[14px] leading-[24px] text-[#414141] border-b">
            <td>
                <Link
                    href={Actions.toStockDetail(ele.nseSymbol ?? ele.bseSymbol, ele.compName)}
                    className="group shadow-[0.5px_0px_0.5px_rgba(0,0,0,0.1)] py-2.5 px-3 mr-8 sticky left-0 bg-white flex flex-row min-w-[360px] max-w-[360px] cursor-pointer"
                >
                    <div className="h-10 w-10 grid place-content-center">
                        {ele.logoUrl === null || ele.logoUrl === "" ? (
                            <div className="h-10 w-10 font-Inter font-extrabold text-[24px] text-[#606060] bg-[#ededed] text-center  rounded-full pt-2">
                                {ele.compName?.slice(0, 1)}
                            </div>
                        ) : (
                            <div>
                                <Image
                                    src={ele.logoUrl}
                                    alt="stock logo"
                                    width={40}
                                    height={40}
                                    className="max-h-10 max-w-10 "
                                />
                            </div>
                        )}
                    </div>
                    <div className="pt-2.5 ml-3 lg:ml-4 text-[14px] leading-[24px] text-[#202020] font-semibold w-[140px] line-clamp-1">
                        {ele.titleWithSubtitle}
                    </div>
                    <OnHoverOption
                        watchListIds={ele?.watchListIds}
                        finCode={ele?.finCode}
                        nseSymbol={ele?.nseSymbol}
                        bseSymbol={ele?.bseSymbol}
                        isOpen={isOpen}
                        exchange={ele?.nseSymbol ? "NSE" : "BSE"}
                        setOpen={setOpen}
                        onClickTradingView={async () => {
                            getLivePrice([ele.finCode]).then((res) => {
                                const parentFinCode = res?.[ele.finCode]?.parentFinCode;
                                if (parentFinCode) {
                                    router.push(Actions.toFNODetail(`${parentFinCode}-${ele?.finCode}`, "/charts"));
                                } else {
                                    router.push(
                                        Actions.toStockDetail(ele.nseSymbol ?? ele.bseSymbol, ele.compName, "/charts")
                                    );
                                }
                            });
                        }}
                    />
                </Link>
            </td>

            {data.param1 && <td className=" p-2.5 mr-4 whitespace-nowrap">{ele.param1}</td>}
            {data.param2 && <td className=" p-2.5 mr-4 whitespace-nowrap">{putCommaWith(ele.param2)}</td>}
            {data.param4 && <td className=" p-2.5 mr-4 whitespace-nowrap">{ele.param4}</td>}
            {data.param5 && <td className=" p-2.5 mr-4 whitespace-nowrap">{putCommaWith(ele.param5)}</td>}
            {data.param6 && (
                <>
                    {specialScreeners.includes(name) ? (
                        <td className=" p-2.5 mr-4">
                            <NseOrBsePrice
                                nseLtpPrice={ltpPrice}
                                nseClosePrice={ele.param5 ?? ele.param4}
                                textClass="whitespace-nowrap"
                            />
                        </td>
                    ) : (
                        <td className=" p-2.5 mr-4">{putCommaWith(ele.param6)}</td>
                    )}
                </>
            )}
            <td className={`p-2.5 mr-4 `}>
                <LivePriceBox ltpPrice={ltpPrice} textClass="text-[14px] leading-[24px] font-semibold text-[#414141]" />
            </td>
            <td>
                <NseOrBsePrice
                    nseLtpPrice={ltpPrice}
                    nseClosePrice={ele.nseSymbol ? ele?.nseClosePrice : ele?.bseClosePrice}
                    textClass="whitespace-nowrap p-2.5 mr-4 text-[14px] leading-[24px] font-semibold"
                />
            </td>

            {data.param3 && (
                <td>
                    <Link
                        id="view-chart-button"
                        className="flex flex-row cursor-pointer  min-w-[130px] max-w-[130px] items-center"
                        href={Actions.toStockDetail(ele.nseSymbol ?? ele.bseSymbol, ele.compName, "/charts")}
                    >
                        <div className=" text-[#00439D] mr-4">View charts</div>
                        <Image src={viewChat} alt="stock logo" className="mt-1 w-4" />
                    </Link>
                </td>
            )}
        </tr>
    );
}
